import { forwardRef, useRef, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

export const PasswordInput = forwardRef(function PasswordInput({ className = "", "data-testid": testid, ...props }, _ref) {
  const [show, setShow] = useState(false);
  const inputRef = useRef(null);
  const reveal = (e) => { e.preventDefault(); setShow(true); inputRef.current?.focus(); };
  const hide = () => setShow(false);
  return (
    <div className={`relative ${className}`}>
      <Input ref={inputRef} type={show ? "text" : "password"} className="pr-10 sm:pr-28" data-testid={testid} {...props} />
      <button
        type="button"
        onPointerDown={reveal}
        onPointerUp={hide}
        onPointerLeave={hide}
        onPointerCancel={hide}
        onKeyDown={(e) => (e.key === " " || e.key === "Enter") && setShow(true)}
        onKeyUp={hide}
        onBlur={hide}
        onContextMenu={(e) => e.preventDefault()}
        aria-label="Tieni premuto per vedere la password"
        className={`absolute right-1.5 top-1/2 flex -translate-y-1/2 select-none items-center gap-1 rounded-md px-2 py-1 text-xs font-600 transition-colors [touch-action:none] ${
          show ? "bg-blue-600 text-white" : "text-slate-500 hover:bg-slate-100 hover:text-slate-800"
        }`}
        data-testid={`${testid}-toggle`}
      >
        {show ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
        <span className="hidden sm:inline">Vedi password</span>
      </button>
    </div>
  );
});
